<script setup lang="ts">
import MsoRepresentativeBody from "@/components/models/practice/detail/MsoRepresentativeBody.vue";
import { useAbility } from "@casl/vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";
import DSODetailHeader from "@/components/shared/headers/DSODetailHeader.vue";
import { useMso } from "@/composables/models/practice/useMsos";
import { useCanAccessDsoRepresentative } from "@/composables/shared/useSectionPermissions";

definePage({
  meta: {
    title: "generic.action.viewEntity",
    titleParams: { entity: "generic.entity.mso" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return (
        can($permActions.READ, $permSubjects.PRACTICE__MSO) && useCanAccessDsoRepresentative().value
      );
    },
  },
});

const route = useRoute();
const msoId = computed(() => (route.params as { id: string }).id);
const { data: mso, isLoading } = useMso({ id: msoId.value });
</script>

<template>
  <div class="tw:pb-4! tw:sm:pb-6!">
    <v-skeleton-loader
      :loading="isLoading"
      type="heading,card"
    >
      <DSODetailHeader :mso="mso" />
      <mso-representative-body :mso="mso" />
    </v-skeleton-loader>
  </div>
</template>
